import React, { ReactNode } from 'react';
import { FieldError } from 'react-hook-form';
import styles from './Form.module.scss';

interface FormFieldProps {
  children: ReactNode;
  error?: FieldError | undefined;
  className?: string;
}

const FormField = ({ children, error, className }: FormFieldProps) => {
  const inputClassName = error
    ? `input ${styles.form__input__error} ${className}`
    : `input ${className}`;

  return (
    <>
      {React.cloneElement(children as React.ReactElement, {
        className: inputClassName,
      })}
      {error && (
        <div
          className={styles.form__input__error__message}
          role="alert"
        >
          {error.message}
        </div>
      )}
    </>
  );
};

export default FormField;
